"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4714],{

/***/ 84714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ graphiql_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@graphiql/react/dist/graphiql-react.es.js
var graphiql_react_es = __webpack_require__(74842);
// EXTERNAL MODULE: ./node_modules/graphiql/esm/index.js + 2 modules
var esm = __webpack_require__(1883);
;// CONCATENATED MODULE: ./services/graphiql-helper-service.js
/* provided dependency */ var process = __webpack_require__(83454);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var getApiUrl = function() {
    var MONDAY_API_URL = "http://api.monday.com/v2";
    var isDevelopment = process.env.ENV == "DEV";
    if (isDevelopment) {
        return MONDAY_API_URL;
    }
    var httpsUrl = MONDAY_API_URL.replace(/^http:/, "https:");
    return httpsUrl;
};
var graphQLFetcher = function(graphQLParams, param) {
    var onAuthorized = param.onAuthorized, tokenString = param.tokenString, version = param.version, headers = param.headers;
    var finalHeaders = _object_spread_props(_object_spread({
        "Content-Type": "application/json"
    }, version ? {
        "API-Version": version
    } : {}, headers || {}), {
        Authorization: tokenString
    });
    return fetch(getApiUrl(), {
        method: "post",
        headers: finalHeaders,
        body: JSON.stringify(graphQLParams)
    }).then(function(response) {
        if (response.status !== 401) {
            onAuthorized();
        }
        return response.json();
    });
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/monday-ui-react-core/dist/icons/Versioning.js
var Versioning = __webpack_require__(99978);
var Versioning_default = /*#__PURE__*/__webpack_require__.n(Versioning);
// EXTERNAL MODULE: ./node_modules/monday-ui-react-core/dist/icons/Locked.js
var Locked = __webpack_require__(57238);
var Locked_default = /*#__PURE__*/__webpack_require__.n(Locked);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./components/pages/developers/try-it-yourself/graphiql/graphiql-component.scss.js


var Z_INDEX = z_index/* MODAL_BACKGROUND */.AE + 1;
var StylesGraphiqlComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ehe6lq50"
})(".CodeMirror-info,.CodeMirror-lint-tooltip{z-index:", Z_INDEX, ';}.CodeMirror *{font-family:SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;}reach-portal{[data-reach-tooltip],[data-reach-popover],[data-reach-dialog-overlay]{z-index:', Z_INDEX, ';}}.graphiql-container,.CodeMirror-info,.CodeMirror-lint-tooltip,reach-portal{/* Colors */\n    --color-primary:211,100%,46%;--color-secondary:242,51%,61%;--color-tertiary:188,100%,36%;--color-info:208,100%,46%;--color-success:158,60%,42%;--color-warning:36,100%,41%;--color-error:13,93%,58%;--color-neutral:219,28%,32%;--color-base:219,28%,100%;/* Color alpha values */\n    --alpha-secondary:0.76;--alpha-tertiary:0.5;--alpha-background-heavy:0.15;--alpha-background-medium:0.1;--alpha-background-light:0.07;/* Font */\n    --font-family:var(--font-family);--font-family-mono:"Fira Code",monospace;--font-size-hint:var(--font-size-subtext);--font-size-inline-code:calc(13rem / 16);--font-size-body:var(--font-size-general-label);--font-size-h4:var(--font-size-h4);--font-size-h3:var(--font-size-h3);--font-size-h2:var(--font-size-h2);--font-weight-regular:400;--font-weight-medium:500;--line-height:1.5;/* Spacing */\n    --px-2:2px;--px-4:4px;--px-6:6px;--px-8:8px;--px-10:10px;--px-12:12px;--px-16:16px;--px-20:20px;--px-24:16px;/* Border radius */\n    --border-radius-2:2px;--border-radius-4:4px;--border-radius-8:8px;--border-radius-12:12px;/* Popover styles (tooltip,dialog,etc) */\n    --popover-box-shadow:0px 6px 20px rgba(59,76,106,0.13),0px 1.34018px 4.46726px rgba(59,76,106,0.0774939),0px 0.399006px 1.33002px rgba(59,76,106,0.0525061);--popover-border:none;/* Layout */\n    --sidebar-width:60px;--toolbar-width:40px;--session-header-height:51px;}height:100%;*{box-sizing:unset;}.disclaimer-text{padding:var(--px-8) var(--px-8) 0 0;text-align:end;}');

;// CONCATENATED MODULE: ./components/pages/developers/try-it-yourself/graphiql/graphiql-default-query.js
var defaultQuery = "\nquery {\n  me {\n    name\n  }\n  \n  # boards(ids:[13542, 68097]) {\n  boards(limit:1) {\n    name\n    \n    columns {\n      title\n      id\n      type\n    }\n    \n    groups {\n    	title\n      id\n    }\n    \n    items {\n      name\n      group {\n        id\n      }\n      \n      column_values {\n        id\n        value\n      }\n    }\n  }\n}";

// EXTERNAL MODULE: ./node_modules/graphiql/graphiql.css
var graphiql = __webpack_require__(43044);
;// CONCATENATED MODULE: ./components/pages/developers/try-it-yourself/graphiql/graphiql-component.js
function graphiql_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function graphiql_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            graphiql_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function graphiql_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function graphiql_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        graphiql_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var VERSIONS_QUERY = "query { versions { kind value } }";
var GraphiqlComponent = function(param) {
    var changeToken = param.changeToken, onAuthorized = param.onAuthorized, token = param.token;
    var ref = (0,react.useState)(), apiVersions = ref[0], setApiVersions = ref[1];
    var ref1 = (0,react.useState)(), version = ref1[0], setVersion = ref1[1];
    var fetcher = (0,react.useCallback)(function(params, opts) {
        return Promise.resolve(token ? graphQLFetcher(params, graphiql_component_object_spread_props(graphiql_component_object_spread({}, opts), {
            onAuthorized: onAuthorized,
            tokenString: token,
            version: version
        })) : undefined);
    }, [
        onAuthorized,
        version,
        token
    ]);
    (0,react.useEffect)(function() {
        fetcher({
            query: VERSIONS_QUERY
        }).then(function(result) {
            var _result_data;
            var newApiVersions = result === null || result === void 0 ? void 0 : (_result_data = result.data) === null || _result_data === void 0 ? void 0 : _result_data.versions;
            setApiVersions(newApiVersions);
            setVersion(function(ver) {
                var newVersion = ver && (newApiVersions === null || newApiVersions === void 0 ? void 0 : newApiVersions.find(function(v) {
                    return v.value === ver;
                })) || (newApiVersions === null || newApiVersions === void 0 ? void 0 : newApiVersions.find(function(v) {
                    return v.kind === "stable";
                }));
                return newVersion === null || newVersion === void 0 ? void 0 : newVersion.value;
            });
        });
    }, [
        fetcher
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StylesGraphiqlComponent, {
        className: "graphiql-component-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* default */.ZP, {
            defaultQuery: defaultQuery,
            fetcher: fetcher,
            toolbar: {
                additionalContent: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(graphiql_react_es/* ToolbarButton */.wC, {
                            label: "Change token",
                            onClick: changeToken,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Locked_default()), {
                                className: "graphiql-toolbar-icon",
                                "aria-hidden": "true"
                            })
                        }),
                        (apiVersions === null || apiVersions === void 0 ? void 0 : apiVersions.length) && version && /*#__PURE__*/ (0,jsx_runtime.jsx)(graphiql_react_es/* ToolbarListbox */.eb, {
                            button: /*#__PURE__*/ (0,jsx_runtime.jsx)(graphiql_react_es/* ToolbarButton */.wC, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Versioning_default()), {
                                    className: "graphiql-toolbar-icon",
                                    "aria-hidden": "true"
                                })
                            }),
                            label: "Selected version",
                            value: version,
                            onChange: setVersion,
                            children: apiVersions.map(function(ver) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(graphiql_react_es/* ToolbarListbox.Option */.eb.Option, {
                                    value: ver.value,
                                    children: [
                                        ver.value,
                                        ver.kind !== ver.value ? " (".concat(ver.kind, ")") : null
                                    ]
                                }, ver.value);
                            })
                        })
                    ]
                })
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default.Logo */.ZP.Logo, {
                    children: "API Playground"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default.Footer */.ZP.Footer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "disclaimer-text",
                        children: "This explorer uses your real monday.com data"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var graphiql_component = (GraphiqlComponent);


/***/ })

}]);